<template>
  <page-content
    title="Konsultasi Psikologi: Riwayat"
    :with-margin="false"
    :back-button="{ name: 'home' }"
  >
    <br />
    <!-- Survey alert -->
    <survey-alert v-if="checkups.length > 0" class="mx-3 mb-3" />
    <mental-health-participant-list
      :data="checkups"
      @item-click="openHistoryDetail"
      search-placeholder="Cari keluhan..."
      show-status-badge
    >
      <template #empty>
        <empty-state icon="psychology" icon-type="rounded" />
      </template>
    </mental-health-participant-list>
    <template v-if="checkups.length == 0">
      <div class="d-flex justify-content-center">
        <button class="btn btn-primary btn-rounded" @click="openRegistration()">
          Daftar Konsultasi
        </button>
      </div>
    </template>
  </page-content>
</template>

<script>
import axios from "axios";
import MentalHealthParticipantList from "./components/MentalHealthParticipantList.vue";
import SurveyAlert from "@/components/SurveyAlert.vue";
import { getCheckupStatus } from "@/helpers/mental-health";

export default {
  name: "mental-health-history",
  components: {
    MentalHealthParticipantList,
    SurveyAlert,
  },
  data: function () {
    return {
      checkups: [],
    };
  },
  methods: {
    getCheckupStatus,
    getHistories: function () {
      this.startPageLoading();
      axios
        .get(this.apiBaseUrl + "mental-health/checkups/own")
        .then((response) => {
          this.stopPageLoading();
          const data = response.data.data;
          const mergeds = data.unscheduleds.concat(
            data.scheduleds,
            data.completeds,
            data.canceleds
          );
          this.checkups = mergeds.map((item) => ({
            ...item,
            status: this.getCheckupStatus(item),
          }));
        });
    },
    openHistoryDetail: function (checkup) {
      this.$router.push({
        name: "mental-health-history-detail",
        params: { id: checkup.id },
      });
    },
    openRegistration: function () {
      this.$router.push({
        name: "mental-health-registration",
      });
    },
  },
  created: function () {
    this.getHistories();
  },
};
</script>
